import type { CardSlotData } from '../ui/AlgorithmCardBar';
import type { AlgorithmCardType } from '../../shared/types';
import { ALGORITHM_CARDS } from '../../shared/types';

interface ServerCard {
  cardType: number;
  tier: number;
  cooldownRemaining: number;
  active: boolean;
}

export class AlgorithmCardManager {
  private slots: CardSlotData[] = [];

  syncFromServer(cards: unknown): void {
    this.slots = [];
    if (!cards) return;

    const cardArray: ServerCard[] = Array.isArray(cards)
      ? cards
      : Array.from(cards as Iterable<ServerCard>);

    for (let i = 0; i < cardArray.length; i++) {
      const card = cardArray[i];
      const def = ALGORITHM_CARDS[card.cardType as AlgorithmCardType];
      const cooldownMs = def ? def.cooldownSec * 1000 : 1;
      this.slots.push({
        slotIndex: i,
        cardType: card.cardType,
        tier: card.tier,
        cooldownFraction: def
          ? Math.max(0, card.cooldownRemaining / cooldownMs)
          : 0,
        active: card.active,
      });
    }
  }

  getCardSlots(): CardSlotData[] {
    return this.slots;
  }

  isSlotReady(index: number): boolean {
    const slot = this.slots[index];
    return slot !== undefined && slot.cooldownFraction <= 0;
  }
}
